import { useTranslation } from 'react-i18next';

const useQuoteSummaryTranslations = () => {
  const { t } = useTranslation();
  const quote = (translationKey: string) => t(`account.recurringPayment.quote.${translationKey}`);

  return {
    summary: {
      heading: quote('summary.heading'),
      text: quote('summary.text'),
    },
    breakdown: {
      description: t('account.billing.table.description'),
      amount: t('account.billing.table.amount'),
      heading: quote('breakdown.heading'),
      text: quote('breakdown.text'),
      quoteTotal: quote('breakdown.quoteTotal'),
      currentBalance: quote('breakdown.currentBalance'),
      amountToPay: quote('breakdown.amountToPay'),
      backToSummary: quote('breakdown.backToSummary'),
    }
  };
}
export default useQuoteSummaryTranslations;